module.exports = {
    // fix phases key to top of viewport on scroll
    init: () => {
        // check screen is larger than our small viewport display of the process map
        if (matchMedia) {
            const minViewport = window.matchMedia("(min-width: 1080px)");
            minViewport.addListener(WidthChange);
            WidthChange(minViewport);
        }
        function WidthChange (minViewport) {
            if (minViewport.matches) {
                // get the phases key header element
                const phasesKeyClass = ".process_map__phases--canonical";
                const phasesKey      = document.querySelector(phasesKeyClass);
                if (!phasesKey) {
                    console.error(`Could not find an element with the selector: ${phasesKeyClass}`);
                    return;
                }
                // get the process map element, so that we can add to it the height of
                // the phases key when fixed, to avoid a sudden jump of content
                const processMapClass = ".process_map";
                const processMap      = document.querySelector(processMapClass);
                if (!processMap) {
                    console.error(`Could not find an element with the selector: ${processMapClass}`);
                    return;
                }
                // get the rendered height of the phases key, to allow us to offset the rest of the content
                // when it is fixed to the top of the viewport
                const phasesKeyHeight = phasesKey.offsetHeight;
                // initialise the variable to determine whether the element is fixed to the viewport
                let fixed = false;
                // determine whether the element has met the top of the viewport
                const stickPoint = phasesKey.offsetTop;
                window.onscroll = function (e) {
                    const distance = stickPoint - window.scrollY;
                    const offset   = window.scrollY;
                    const parentWidth = document.getElementsByClassName("process_map")[0].scrollWidth;
                    if ((distance <= 0) && !fixed) {
                        phasesKey.style.position   = "fixed";
                        phasesKey.style.top        = "0";
                        phasesKey.style.width      = parentWidth + "px";
                        processMap.style.marginTop = phasesKeyHeight + "px";
                        fixed = true;
                    } else if (fixed && (offset <= stickPoint)) {
                        phasesKey.style.position   = "static";
                        phasesKey.style.top        = "auto";
                        phasesKey.style.width      = "auto";
                        processMap.style.marginTop = "0";
                        fixed = false;
                    }
                };
            }
        }
    }
};
